// extracted by mini-css-extract-plugin
export default {"container":"container--bkYuG","heading":"heading--d1QEg","title":"title--KtP2x","main":"main--DAtWe","footer":"footer--o9T6X","footerPadding":"footerPadding--P9fVR"};